import React, { useEffect, useMemo, useState } from 'react'
import employeeService from 'Services/employeeService'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { kpiPart } from 'Helpers/appraisalRating'

import { EmployeeType } from 'Models'
import profileService from 'Services/profileService'
import { useWatch } from 'react-hook-form'

interface matricType {
  id: number
  userId: string
  relevance: number
  metric: string
  createdAt: string
}

export const useStepTwo = ({ employeeId, control }: { employeeId?: string; control?: any }) => {
  const { showAlert } = ShowTGAlert()

  const [pageNumber, setPage] = useState(1)
  const [kpi, setKpi] = useState<matricType[]>()

  const [loading, setLoading] = useState(false)
  const [request, setRequest] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [sortOrder, setSortOrder] = useState('DESC')

  const [profile, setProfile] = useState<EmployeeType>()

  const getProfile = async () => {
    await profileService.profile().then((response) => {
      // console.log('profileService', response.data.data)
      setProfile(response.data.data)
    })
  }

  useEffect(() => {
    getProfile()
  }, [])

  const getUserKpi = async () => {
    setLoading(true)

    await employeeService.kpiIndex(employeeId ? employeeId : profile?.id).then(
      (response) => {
        // console.log('employeeService', response?.data)
        setLoading(false)

        const dataSet = response?.data.data
        setKpi(dataSet)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: { data: { error: string } } }) => {
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })

        setLoading(false)
      },
    )
  }

  useEffect(() => {
    if (profile) getUserKpi()
  }, [pageNumber, sortOrder, profile])

  // const kpiTotal = (watch && watch('kpi')) || []
  const kpiTotal = useWatch({ control, name: 'kpi' })

  console.log('kpiTotal', kpiTotal)

  const kpiPercentage = kpiPart(kpiTotal, 'employee_score').toFixed(2)
  const kpiPercentageMgr = kpiPart(kpiTotal, 'manager_score').toFixed(2)

  return {
    pageNumber,
    setPage,
    kpi,
    loading,
    request,
    paginationData,
    sortOrder,
    profile,
    kpiTotal,
    kpiPercentage,
    kpiPercentageMgr,
    setSortOrder,
    setRequest,
  }
}
